import { TMainVisualFormData } from 'src/@types';
import { IMainVisual } from 'src/models';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import { HEADERS_MULTIPART } from 'src/static/constants';

const SUB_URL = '/v1/visual';

const convertDataInfoToFormData = (data: TMainVisualFormData) => {
  const formData = new FormData();

  // 이미지 파일 추가 (detailImage는 배열로 가정)
  if (data.bgPath && data.bgPath.length > 0) {
    data.bgPath.forEach((file, index) => {
      formData.append(`bgPath[${index}]`, file);
    });
  }
  if (data.deleteFilesPath && data.deleteFilesPath.length > 0) {
    data.deleteFilesPath.forEach((file) => {
      formData.append(`deleteFilesPath`, file);
    });
  }

  // 새로 업로드된 파일 추가
  if (data.files && data.files.length > 0) {
    data.files.forEach((file, index) => {
      formData.append(`bgFiles[${index}]`, file);
    });
  }

  formData.append('mainText', data.mainText || '');
  formData.append('subText', data.subText || '');
  formData.append('mainTextColor', data.mainTextColor || '');
  formData.append('subTextColor', data.subTextColor || '');
  formData.append('useYn', data.useYn.toString());
  formData.append('ordr', data.ordr.toString());
  formData.append('langCd', data.langCd || '');

  return formData;
};

/**
 * 메인 비주얼 목록 조회
 */
export const getMainvisual = async () => {
  try {
    const url = SUB_URL;
    const response = await instance.get<TApiResponseData<IMainVisual[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 메인 비주얼 상세 조회
 */
export const getDetail = async (visualSid: number) => {
  try {
    const url = `${SUB_URL}/${visualSid}`;
    const response = await instance.get<TApiResponseData<IMainVisual>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 메인 비주얼 등록
 */
export const post = async (data: TMainVisualFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);
    const url = `${SUB_URL}`;
    // 파일 크기 로깅
    if (data.files && data.files.length > 0) {
      data.files.forEach((file, index) => {
        const fileSizeInMB = (file.size / (1024 * 1024)).toFixed(2);
        console.log(`파일 ${index + 1} 크기: ${fileSizeInMB} MB`);
      });
    }

    const response = await instance.post<TApiResponseData<IMainVisual>>(
      url,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 메인 비주얼 수정
 */
export const put = async (visualSid: number, data: TMainVisualFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);
    const url = `${SUB_URL}/${visualSid}`;

    const response = await instance.put<TApiResponseData<IMainVisual>>(
      url,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 메인 비주얼 삭제
 */
export const remove = async (visualSid: number) => {
  try {
    const url = `${SUB_URL}/${visualSid}`;
    const response = await instance.delete<TApiResponseData<IMainVisual>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * TODO 수정 API 변경되면 제거 예정
 * 메인 비주얼 순서 변경
 */
export const changeOrder = async (data: IMainVisual[]) => {
  try {
    const url = `${SUB_URL}/order`;
    const response = await instance.put<TApiResponseData<IMainVisual>>(url, data);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
